import { useState, forwardRef, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Grid,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import request from "../../../utilities/requests";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UserDialog = ({ open, close, user }) => {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [notes, setNotes] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);

  useEffect(() => {
    if (user?.email) setEmail(user.email);
    if (user?.firstName) setFirstName(user.firstName);
    if (user?.lastName) setLastName(user.lastName);
    if (user?.notes) setNotes(user.notes);
  }, [user]);


  const handleSave = async () => {
    const body = {
      email,
      firstName,
      lastName,
      notes,
    };
    if (user) {
      const result = await request("blacklist/update", "post", body);
      if (result.success) {
        handleClose("update-success");
        return;
      }
    } else {
      const result = await request("blacklist/create", "post", body);
      if (result.success) {
        handleClose("create-success");
        return;
      }
    }
  };

  const handleDelete = async () => {
    const body = { email };
    const result = await request("blacklist/delete", "post", body);
    if (result.success) {
      setConfirmOpen(false);
      handleClose("delete-success");
    }
  };

  const handleClose = (msg) => {
    setEmail("");
    setFirstName("");
    setLastName("");
    setNotes("");
    close(msg);
  };

  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={() => handleClose(null)}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => handleClose(null)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {user ? "Edit Blacklist Entry" : "New Blacklist Entry"}
            </Typography>
            <Button autoFocus color="inherit" onClick={handleSave}>
              save
            </Button>
          </Toolbar>
        </AppBar>

        <DialogContent>
          <Grid container direction="column" spacing={3}>
            <Grid item>
              <TextField
                fullWidth
                label="email*"
                value={email}
                disabled={user ? true : false}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Grid>

            <Grid item>
              <TextField
                fullWidth
                label="first name*"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </Grid>
            <Grid item>
              <TextField
                fullWidth
                label="last name*"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </Grid>
            <Grid item>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="notes*"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                onClick={handleSave}
                style={{ width: "100%" }}
              >
                Save
              </Button>
            </Grid>
            {user ? (
              <Grid item>
                <Button
                  variant="outlined"
                  onClick={() => setConfirmOpen(true)}
                  style={{ width: "100%" }}
                >
                  Delete
                </Button>
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        </DialogContent>
      </Dialog>
      <Dialog open={confirmOpen}>
        <DialogTitle id="alert-dialog-title">Please confirm</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this person from the blacklist?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>cancel</Button>
          <Button autoFocus onClick={handleDelete}>
            delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UserDialog;
